import { SocialNetworksWeb } from "./web";
import { SocialNetworksBlockProps } from "./types";

export function SocialNetworksWebEditor(props: SocialNetworksBlockProps) {
  return <SocialNetworksWeb {...props} />;
}
